import { render, staticRenderFns } from "./privacypolicy.vue?vue&type=template&id=b30e7c5a&scoped=true"
import script from "./privacypolicy.vue?vue&type=script&lang=js"
export * from "./privacypolicy.vue?vue&type=script&lang=js"
import style0 from "./privacypolicy.vue?vue&type=style&index=0&id=b30e7c5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30e7c5a",
  null
  
)

export default component.exports